import {useEffect, useState} from 'react'
import {Form} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import Select from 'react-select'

export const TimeDimensionGroupFilter = (props: any) => {
  const intl = useIntl()
  const [grouping, setGrouping] = useState<string>('0')
  const [groupingOptionSelected, setGroupingOptionSelected] = useState({value: 'localYear', label: intl.formatMessage({id: 'GENERIC.YEAR'})})

  useEffect(() => {
    props.onChangedGrouping?.(grouping)
  }, [props, grouping]);

  useEffect(() => {
    props.onChangedGroupingOption?.(groupingOptionSelected)
  }, [props, groupingOptionSelected]);
  return (
    <>
      <div className='row mb-3'>
        <div className='col-12'>
          <label htmlFor='date_range' className='fw-bold fs-6'>
            {intl.formatMessage({
              id: 'GENERIC.TIME_DIMENSION_AGGREGATION_LEVEL',
            })}
          </label>
          <Form.Check
            type='radio'
            id='dayly_values'
            value='0'
            label={intl.formatMessage({
              id: 'GENERIC.DAYLY_VALUES',
            })}
            checked={grouping === '0'}
            onChange={(e) => setGrouping(e.target.value)}
            className='mb-2'
          />
          <Form.Check
            type='radio'
            id='grouping_by'
            value='1'
            label={intl.formatMessage({
              id: 'GENERIC.GROUPING_BY',
            })}
            checked={grouping === '1'}
            className='mb-2'
            onChange={(e) => setGrouping(e.target.value)}
          />

          {grouping === '1' && (
            <>
              <label htmlFor='grouping_by' className='fw-bold fs-6'>
                {intl.formatMessage({
                  id: 'GENERIC.GROUPING_TIME_DIMENSION',
                })}
              </label>
              <div className='col-12'>
                <Select
                  name='server_group'
                  options={[
                    {value: 'localYear', label: intl.formatMessage({id: 'GENERIC.YEAR'})},
                    {value: 'localQuarter', label: intl.formatMessage({id: 'GENERIC.QUARTER'})},
                    {value: 'localMonth', label: intl.formatMessage({id: 'GENERIC.MONTH'})},
                    {value: 'localWeekNum', label: intl.formatMessage({id: 'GENERIC.WEEK_NUMBER'})},
                    {value: 'localWeekDay', label: intl.formatMessage({id: 'GENERIC.WEEK_DAY'})},
                    {value: 'localHourSlot', label: intl.formatMessage({id: 'GENERIC.HOUR_SLOT'})},
                  ]}
                  classNamePrefix='select'
                  onChange={(selectedOption) => {
                    setGroupingOptionSelected(selectedOption)
                  }}
                  value={groupingOptionSelected}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </>
  )
}
